export enum HttpStatusCategory {
  SUCCESS = 'success',
  ERROR = 'error',
  PENDING = 'pending'
}

export enum SchemaType {
  STRING = 'string',
  NUMBER = 'number',
  INTEGER = 'integer',
  BOOLEAN = 'boolean',
  OBJECT = 'object',
  ARRAY = 'array'
}

export enum SchemaFormat {
  EMAIL = 'email',
  PASSWORD = 'password',
  URI = 'uri',
  DATE = 'date',
  DATE_TIME = 'date-time',
  UUID = 'uuid'
}

export interface IJSONSchemaProperty {
  type?: SchemaType;
  title?: string;
  description?: string;
  enum?: string[];
  format?: SchemaFormat;
  default?: unknown;
  minLength?: number;
  maxLength?: number;
  minimum?: number;
  maximum?: number;
  pattern?: string;
  properties?: Record<string, IJSONSchemaProperty>;
  required?: string[];
  items?: IJSONSchemaProperty;
  readOnly?: boolean;
  isHidden?: boolean;
  $ref?: string;
}

export interface IJSONSchema {
  type: SchemaType.OBJECT;
  title?: string;
  description?: string;
  properties: Record<string, IJSONSchemaProperty>;
  required?: string[];
  definitions?: Record<string, IJSONSchemaProperty>;
}

export type FormValues = Record<string, unknown>;

export type RequestHeaders = Record<string, string>;

export interface IExecuteResultDto {
  success: boolean;
  statusCode: number;
  responseHeaders: Record<string, string>;
  responseBody: unknown;
}

export interface IExecuteIntegrationTestRequestDto {
  headers: RequestHeaders;
  payload: FormValues;
}

export type FetchHeaders = (payload: FormValues) => Promise<RequestHeaders>;

export interface IIntegrationTestModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  schema: IJSONSchema;
  url: string;
  fetchHeaders: FetchHeaders;
  defaultValues?: FormValues;
  schemaNames: string[];
  selectedSchemaName: string | undefined;
  onSchemaChange: (schemaName: string) => void;
  onTest: (request: IExecuteIntegrationTestRequestDto) => Promise<IExecuteResultDto>;
  isLoading: boolean;
  schemaSelectorLabel?: string;
}
